import { useSelector } from "react-redux"
import { getLocationNameFromId } from "../../../../lib/labels";
import Tag from "../../../fragments/Tag";
import { formatDateLocal } from "../../../../lib/script";
import TableNameLink from "../../../common/TableNameLink";
import SimpleCopyTextButton from "../../../common/SimpleCopyTextButton";
import CancelTransfer from "../../../transfers/CancelTransfer";
import CompleteTransfer from "../../../transfers/CompleteTransfer";
import { transfers_table_header_cells } from "../../../../assets/data";
import MockRows from "../../../mock/MockRows";

export default function TranfersList() {
    const transfersList = useSelector(state => state.transfers.dashboardList)
    const loading = useSelector(state => state.transfers.loading)
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const canCompleteTransfer = !!editPermissions?.practice_complete_transfer
    const COLROS = {
        Pending: 'yellow',
        Completed: 'green',
        Review: 'red'
    }

    return <>
        {loading && 
            <MockRows numberOfRows={transfers_table_header_cells.length}/>
        }
        {transfersList && transfersList.data && transfersList.data.map(item => (
            <tr key={item.id}>
                <td><SimpleCopyTextButton textToCopy={item?.patient?.person_number} /></td>
                <td className="table-cell-no-padding">
                    <TableNameLink text={item?.patient?.name} case_id={item?.case_id} case_data={item}/>                             
                </td>
                <td>{getLocationNameFromId(item?.from_location_id)}</td>
                <td>{getLocationNameFromId(item?.to_location_id)}</td>
                <td>
                    <Tag color={COLROS[`${item.status}`]}>{item.status}</Tag>                    
                </td>
                <td>{item.reason}</td>
                <td>{formatDateLocal(item.first_appointment_date)}</td>
                <td>
                    {(item.status == 'Pending' || item.status == 'Review') ? (
                        <div className="flex-container">
                            {canCompleteTransfer && (
                                <CompleteTransfer caseID={item?.case_id} transferData={item} />
                            )}
                            <CancelTransfer caseID={item?.case_id} transferData={item} onDashboard={true} />
                        </div>
                    ) : '-'}
                </td>
            </tr>
        ))}
        {!transfersList || (transfersList && transfersList.data && transfersList.data.length == 0) && <tr>
            <td colSpan={transfers_table_header_cells.length}>No items found</td>
        </tr>}
    </>
}
